import template from './underground.jade';
import validation from '../../../services/validation';
import debouncePromise from 'debounce-promise';
import './typeahead-item.tpl.jade';
import uuid from 'node-uuid';
import { getUndergroundDistance } from '../../../services/geo.service';
import { compareByWalkTime } from './utils';
import { VALIDATION_PARAMS } from './constants';

import { trackUndergroundAdd, trackUndergroundDistanceChange } from '../tracking/tracking';

const experimentObjects = ['flat', 'room', 'bed', 'flatShare'];

export default angular
  .module('cian.addForm.underground', [])
  .directive('isUndergroundSelected', () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: (scope, element, attrs, ngModel) => {
        ngModel.$validators.selected = value => {
          value = scope.viewModel.viewValue;
          if (angular.isObject(value)) {
            return value.name && !value.id ? false : true;
          }
          return !value || !value.trim() ? true : false;
        };
      }
    };
  })
  .directive('cianAfAddressUnderground', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      categoryInfo: '=',
      form: '=',
    },
    controller: [
      'apiService', '$q', '$scope', 'addressService', 'addFormService', 'analyticsService', 'deviceService',
      function (apiService, $q, $scope, addressService, addFormService, analyticsService, deviceService) {
      // максимальное кол-во метро

      this.isMobile = deviceService.isMobile;
      this.maxCount = 3;
      this.isFocused = false;
      this.ad.geo = this.ad.geo || {};
      this.ad.geo.undergrounds = this.ad.geo.undergrounds || [];
      this.getLocationId = () => addressService.locationId;

      this.loadingSuggestions = [];

      this.hasUndergrounds = () => this.undergrounds.length > 0;
      this.isEnabled = () => addressService.isUndergroundEnabled();
      this.isHighwayEnabled = () => addressService.isHighwayEnabled();

      const updateViewModels = () => {
        this.viewModels = this.undergrounds.map((u) => {
          if (!u.uuid) {
            u.uuid = uuid.v4();
          }

          return {
            underground: u,
            viewValue: {id: u.id, name: u.name}, // сюда пишет typeahead
          };
        });
      };

      // https://github.com/angular-ui/bootstrap/issues/5136
      this.forceValidation = el => {
        el.$validate();
      };

      this.focusInput = () => {
        this.isFocused = true;
      };

      this.blurInput = (viewModel) => {
        this.isFocused = false;
        this.updateModel(viewModel, true);
      };

      this.updateModel = (viewModel, isTrackingDisabled) => {
        const viewValue = viewModel.viewValue;
        const newUnderground = angular.isObject(viewValue) ? viewValue : { id: null, lineColor: null, name: viewValue || '' };

        Object.assign(viewModel.underground, newUnderground);

        if (!isTrackingDisabled) {
          trackUndergroundAdd(viewModel.underground.id || '', analyticsService.adAnalyticsCategory);
        }

        if (!viewModel.underground.name) {
          viewModel.underground.time = '';
          viewModel.underground.transportType = 'walk';
          if (viewModel.underground.isDefault) {
            this.setDefault(findFirst()); // переключаем дефолт на первое активное
          }
        } else if (this.undergrounds.filter(u => u.id || u.name).length == 1) {
            this.setDefault(viewModel.underground); // переключаем дефолт с неактивных
        }
      };

      this.undergroundValidation = validation(this.form, undefined, {
        selected: 'Неверное название станции',
      });

      // видимость тултипа, показываем ошибку только когда в модель записано невалидное значение
      this.isUndergroundInvalid = index => {
        const isModelValid = this.undergrounds[index].id || !this.undergrounds[index].name;

        return !isModelValid && this.undergroundValidation.invalid(`geo.undergrounds.${index}.id`);
      };

      this.timeValidation = validation(this.form, undefined, VALIDATION_PARAMS);

      // найти метро по id или первое пустое
      const findSlot = id => {
        return this.undergrounds.find(u => u.id == id) || this.undergrounds.find(u => !u.name);
      };

      // найти первое непустое метро
      const findFirst = () => {
        return this.undergrounds.find(u => u.id) || this.undergrounds.find(u => u.name) || this.undergrounds[0];
      };

      /**
       * Добавить метро:
       * - если такое метро уже есть - его значения перезаписываются
       * - если есть пустое - запишется на его место
       * - если достигнуто максимальное кол-во - добавится вместо последнего
       * @param underground метро
       */
      this.addUnderground = (underground, isViewModelUpdateNeeded = true) => {
        if (underground) {
          // findSlot отдаст или пустую станцию или объект уже добавленной станции
          const found = findSlot(underground.id)
          if (found) {
            if (!found.time || found.time > underground.time) {
              Object.assign(found, underground, { uuid: null });
            }
          } else if (this.undergrounds.length < this.maxCount) {
            this.undergrounds.push(underground);
          }
        } else {
          this.undergrounds.push({
            name: '',
            transportType: 'walk'
          });
        }

        this.undergrounds.sort(compareByWalkTime);

        // Если есть станция, а она есть только когда мы автоматически добавляем станцию(из геокодера, или саджеста)
        // Сделать первую станци основной, остальные станции сделать не основными
        if (underground) {
          this.undergrounds.forEach((item, index) => {
            item.isDefault = index === 0;
          });
        }

        if (isViewModelUpdateNeeded) {
          updateViewModels();
        }
      };

      let oldDistance = 0;

      this.startUndergroundDistanceEditing = (viewModel) => {
        oldDistance = viewModel.underground.time;
      };

      this.endUndergroundDistanceEditing = (viewModel) => {
        if (oldDistance !== viewModel.underground.time && !!viewModel.underground.time) {
          trackUndergroundDistanceChange(analyticsService.adAnalyticsCategory);
        }

        oldDistance = 0;
      };

      this.deleteUnderground = underground => {
        const index = this.undergrounds.indexOf(underground);
        if (index > -1) {
          this.undergrounds.splice(index, 1);
          this.loadingSuggestions.splice(index, 1);
        }
        if (underground.isDefault) {
          this.setDefault(findFirst());
        }
        updateViewModels();
      };

      // удалить все станции метро
      const clearUndergrounds = () => {
        this.undergrounds.splice(0, this.undergrounds.length);
        this.addUnderground(undefined, false);
      };

      const getSuggestions = (queryText, index) => {
        if (!queryText || !addressService.geoObject) return $q.when([]);

        const query = {
          term: queryText,
          locationId: addressService.geoObject.locationId
        };

        const selected = this.viewModels
          .map(vm => vm.viewValue && vm.viewValue.id)
          .filter(id => id);

        this.loadingSuggestions[index] = true;

        return apiService.undergrounds(query, { cache: true })
          .then(data => {
            const stations = data.data.undergrounds
              .filter(u => !selected.includes(u.id))
              .map(station => ({
                ...station,
                locationId: this.getLocationId(),
              }));
            if (stations.length === 1 && !this.isFocused) {
              const viewModel = {
                underground: this.undergrounds[index],
                viewValue: stations[0],
              };
              this.updateModel(viewModel);
              updateViewModels();
            }
            return stations;
          })
          .finally(()=> {
            this.loadingSuggestions[index] = false;
          });
      };

      this.getSuggestions = debouncePromise(getSuggestions, 600);

      this.setDefault = underground => {
        this.undergrounds.forEach(u => {
          u.isDefault = u === underground;
        });
      };

      /**
       * Добавляем метро от геокодера при изменении адреса.
       * @param geoObject данные от геокодера
       * @param init true/false - перове изменение адреса при открытии на редактирование
       * @param isJk изменение адреса вызвано выбором ЖК
       */
      const onAddressChanged = (geoObject, init, isJk, locationChanged) => {
        if (init || !geoObject) return;

        if (locationChanged || (addFormService.isJkCategory() && geoObject.jkHashKey)) {
          clearUndergrounds();
        }

        if (geoObject.underground && (isJk || (geoObject.geoType === 'house'))) {
          geoObject.underground.forEach(u => {
            const undergroundDistance = getUndergroundDistance(u);

            const val = {
              id: u.id,
              lineColor: u.lineColor || u.color,
              name: u.name,
              ...undergroundDistance,
            };

            this.addUnderground(val);
          });
        }

        if (!geoObject.hasMetro) {
          this.undergrounds.splice(0, this.undergrounds.length);
          this.loadingSuggestions.splice(0, this.undergrounds.length);
        }

        updateViewModels();
      };

      $scope.$on('geo.address.changed', (event, address, geoObject, isValid, locationChanged, init, isJk) => onAddressChanged(geoObject, init, isJk, locationChanged));

      $scope.$watch(() => this.ad.geo.undergrounds, undergrounds => {
        this.undergrounds = this.ad.geo.undergrounds || [];

        if (this.undergrounds.length > 0 && !this.undergrounds.find(u => u.isDefault)) {
          this.undergrounds[0].isDefault = true;
        }

        updateViewModels();
      });
    }],
    controllerAs: 'ctrl',
    template,
  }))
  .name;
